import { CdkDragDrop } from '@angular/cdk/drag-drop';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import {
  DragMoveEvent,
  IDragdropCard,
  Iicon,
  IInnerItem,
} from './dragdrop-card.model';

@Component({
  selector: 'dragdrop-card',
  templateUrl: './dragdrop-card.component.html',
  styleUrls: ['./dragdrop-card.component.scss'],
})
export class DragDropCardComponent {
  @Input()
  cards: IDragdropCard[] = [];

  @Input()
  headTemplate: TemplateRef<any>;

  @Input()
  cardItemTemplate: TemplateRef<any>;

  @Input()
  cardTrackBy: Function = (index: number, item: IDragdropCard) => item.label;

  @Input()
  cardItemTrackBy: Function = (index: number, item: IInnerItem) => item.data;

  @Input()
  styleClass: any;

  @Input()
  style: any;

  @Output()
  dragMoveEvent: EventEmitter<DragMoveEvent> = new EventEmitter();

  getStyle(action: Iicon) {
    return action.getStyle?.();
  }

  onDropCardItem(param: CdkDragDrop<any>) {
    const { previousContainer, container, previousIndex, currentIndex, item } =
      param;
    if (previousContainer === container && previousIndex === currentIndex)
      return;

    const previousCard = previousContainer.data as IDragdropCard;
    const currentCard = container.data as IDragdropCard;
    const target = item.data as IInnerItem;
    this.dragMoveEvent.emit({
      previousCard,
      currentCard,
      previousIndex,
      currentIndex,
      target,
    });
  }
}
